import React, { useRef } from 'react';

const TaskerComponent = (/* props: IPlatformProjectProps */) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const textRef = useRef<HTMLDivElement | null>(null);
	const bulbRef = useRef<HTMLImageElement | null>(null);
	const imageRef = useRef<HTMLImageElement | null>(null);
	const bgRef = useRef<HTMLDivElement | null>(null);
	
	return (
		<div className="taskerComponent projectsPanel" ref={containerRef} id="testComp__content_data_item_id_2">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="taskerComponent__content">
					<div
						className="taskerComponent__content_data"
						ref={textRef}
					>
						<h2>Manage your tasks</h2>
						<span>Organize the work right inside the platform: plan, make lists, etc</span>
					</div>
					<div className="taskerComponent__content_bulb">
						<div
							className="taskerComponent__content_bulb_img"
							ref={bulbRef}
						>
							<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/Idea.svg`}  alt={'Idea'}/>
						</div>
					</div>
					<div
						className="taskerComponent__content_image"
						ref={imageRef}
					>
						<div
							className="taskerComponent__content_image_background"
							ref={bgRef}
						></div>
						<img src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/tasker/MainImage.webp`} alt="Main"/>
					</div>
			</div>
		</div>
	);
};

export default TaskerComponent;